import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { Text } from 'theme-ui';
import SpinnerBar from '~/components/Spinner/loader';
import CTAButton from '~/components/Generic/CTAButton';
import { useTranslate } from '~/hooks/utils/use-translate';

const ProductAddToCartButton = ({
  discontinued,
  outOfStock,
  comingSoon,
  disabled,
  quantityReached,
  isLoading,
  error,
  freeShipping,
  preOrder,
}) => {
  const translate = useTranslate();
  const btnText = preOrder
    ? 'Pre-Order'
    : comingSoon
    ? translate('product.coming_soon')
    : discontinued
    ? translate('product.discontinued')
    : outOfStock
    ? translate('product.sold_out')
    : quantityReached
    ? 'Limit Reached'
    : translate('product.add_to_cart');
  return (
    <Fragment>
      <CTAButton
        data-testid="add-to-cart-button"
        baseColor="Black"
        size="Medium"
        variant="Filled"
        type="submit"
        forwardSx={{
          width: '100%',
          ...(preOrder && {
            backgroundColor: '#2D9152',
            borderColor: '#2D9152',
            '&:enabled:hover': {
              backgroundColor: '#2D9152E6',
              borderColor: '#2D9152E6',
            },
          }),

          ':disabled': {
            backgroundColor: 'cloud',
          },
        }}
        disabled={disabled || isLoading}
        loading={JSON.stringify(isLoading)}
      >
        {isLoading ? <SpinnerBar /> : btnText}
      </CTAButton>
      {freeShipping ? (
        <Text
          sx={{
            textAlign: 'center',
            fontSize: ['1.2rem', '1.4rem'],
            lineHeight: 1.3,
          }}
          dangerouslySetInnerHTML={{ __html: freeShipping?.description?.childMarkdownRemark?.html }}
        />
      ) : null}
      <Text variant="formError" forwardSx={{ textAlign: 'center', mt: 1 }}>
        {error?.toString()}
      </Text>
    </Fragment>
  );
};

ProductAddToCartButton.propTypes = {
  discontinued: PropTypes.bool,
  comingSoon: PropTypes.bool,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  error: PropTypes.any,
};

ProductAddToCartButton.defaultProps = {
  discontinued: false,
  comingSoon: false,
  disabled: false,
  isLoading: false,
  error: null,
};

export default ProductAddToCartButton;
